import React from "react";
import PropTypes from "prop-types";
import ItemMenu from "../ItemMenu/ItemMenu";
import { trackSubmenuClick } from "../../lib/analytic/trackMainMenu";

const SubMenu = ({
  childrenItems,
  setShowMainMenu,
  buttonBackText,
  isMobile,
  buttonCloseFocus,
  isCapabilitiesMenu,
  toggleModal,
}) => {
  // Check if menu item have submenu.
  const haveChildren =
    Object.keys(childrenItems).length !== 0 &&
    childrenItems.constructor === Object;
  // Prepare submenu array.
  const subMenus = haveChildren && Object.values(childrenItems?.columns);
  // Subtitle for submenus.
  const subtitleMenus = childrenItems?.subtitle;
  // Prepare link after sub menu.
  const linkBottom = childrenItems?.linkBottom;
  // Render submenu links.
  const printChildrenItems = (links) =>
    links.map((link) => (
      <ItemMenu key={link.id} link={link} isMobile={isMobile} toggleModal={toggleModal} />
    ));
  // Func for back to main menu from submenu.
  const backToMainMenu = () => {
    setShowMainMenu(true);
    // Set focus to close btn if out of submenu.
    buttonCloseFocus.current.focus();
  };
  const subMenuColWidthClass = childrenItems?.colWidthSetting ? childrenItems.colWidthSetting : "even";
  const capabilitiesSubMenuClass = isCapabilitiesMenu ? "capabilities" : "";
  return (
    <div className={`submenu__inner col-width-${subMenuColWidthClass} ${capabilitiesSubMenuClass}`} role="presentation">
      {isMobile && (
        <div className="submenu__overlay-btn mt-n40" role="presentation">
          <button
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus
            onClick={backToMainMenu}
            type="button"
            className="submenu__move-back font-600 mt-4 mb-40"
            aria-label="Back to main menu"
          >
            <span aria-hidden="true">{buttonBackText}</span>
          </button>
        </div>
      )}
      {subtitleMenus && (
        <p className="mb-0 subtitle submenu__subtitle-menus mb-16">
          {subtitleMenus}
        </p>
      )}
      {subMenus &&
        subMenus.map((column,index) => {
          const firstChild = column[0];
          const wrapperClass = firstChild.image
            ? "submenu__wrap-menu--language"
            : "";
          return (
            <div
              className={`submenu__wrap-menu ${wrapperClass} ${firstChild?.extraClass ? firstChild.extraClass : ""}`}
              key={'submenu__column-' + index}
              role="presentation"
            >
              {column.map((childItem) => {
                const titleClass = childItem.image
                  ? "font-600 submenu__text"
                  : "subtitle mb-16";
                return (
                  <div className="submenu__item"
                      key={childItem.id}
                      role="presentation"
                      >
                    <div className="submenu__description" role="presentation">
                      <div className="submenu__description__inner" role="presentation">
                        {childItem.image && (
                          <div
                            role="presentation"
                            className="submenu__image"
                            /* eslint-disable-next-line react/no-danger */
                            dangerouslySetInnerHTML={{
                              __html: childItem.image,
                            }}
                          />
                        )}
                        {childItem.subtitle && (
                          <p className={`mb-0 ${titleClass}`} aria-hidden="true">
                            {childItem.subtitle}
                          </p>
                        )}
                      </div>
                    </div>
                    <ul aria-label={childItem.subtitle} role="menu">
                      {printChildrenItems(childItem.links)}
                    </ul>
                  </div>
                )
              })}
            </div>
          );
        })}
      {linkBottom && (
        <div className="submenu__link-bottom-wrap pt-lg-16 pb-lg-16 d-lg-flex justify-content-center">
          <a
            className="link link--tertiary link--small"
            href={linkBottom.url}
            onClick={() => {
              trackSubmenuClick(linkBottom.text, linkBottom.url);
            }}
          >
            {linkBottom.text}
          </a>
        </div>
      )}
    </div>
  );
};

SubMenu.defaultProps = {
  setShowMainMenu: null,
  buttonBackText: "",
  isMobile: false,
  buttonCloseFocus: {},
};

SubMenu.propTypes = {
  childrenItems: PropTypes.object.isRequired,
  setShowMainMenu: PropTypes.func,
  buttonBackText: PropTypes.string,
  isMobile: PropTypes.bool,
  buttonCloseFocus: PropTypes.object,
  toggleModal: PropTypes.func,
};

export default SubMenu;
